export default "__VITE_ASSET__YzRfRbEC__";